import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/log.png';

const HARDCODED = {
  username: 'SalmanParees',
  password: 'Salman@2026'
};

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (username === HARDCODED.username && password === HARDCODED.password) {
      navigate('/invoice');
    } else {
      setError('Invalid username or password. Please try again.');
    }
  };

  return (
    <main className="login-page">
      <style>{`
        * { box-sizing: border-box; }
        .login-page {
          min-height: 100vh;
          display: grid;
          place-items: center;
          padding: 32px 20px;
          background:
            radial-gradient(circle at 15% 15%, rgba(232, 93, 63, .12), transparent 28%),
            linear-gradient(135deg, #EEF3F8 0%, #F8FAFC 52%, #EEF2F7 100%);
          color: #0B1F3A;
          font-family: Inter, "Segoe UI", Arial, sans-serif;
        }
        .login-shell {
          display: grid;
          grid-template-columns: minmax(280px, .95fr) minmax(340px, 1.05fr);
          width: min(100%, 920px);
          min-height: 550px;
          overflow: hidden;
          border: 1px solid rgba(11, 31, 58, .08);
          border-radius: 24px;
          background: #fff;
          box-shadow: 0 28px 80px rgba(11, 31, 58, .16);
        }
        .login-brand {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 46px 36px;
          background: linear-gradient(145deg, #08192E 0%, #0B1F3A 58%, #173D68 100%);
          color: #fff;
          text-align: center;
        }
        .login-brand::before, .login-brand::after {
          position: absolute;
          content: "";
          width: 260px;
          height: 260px;
          border: 1px solid rgba(255, 255, 255, .08);
          border-radius: 50%;
          pointer-events: none;
        }
        .login-brand::before { top: -150px; left: -105px; }
        .login-brand::after { right: -165px; bottom: -160px; width: 340px; height: 340px; }
        .login-logo {
          z-index: 1;
          display: block;
          width: min(100%, 290px);
          max-height: 260px;
          padding: 10px;
          border-radius: 16px;
          background: #fff;
          object-fit: contain;
          margin-bottom: 24px;
          filter: drop-shadow(0 12px 24px rgba(0, 0, 0, .22));
        }
        .brand-kicker {
          z-index: 1;
          margin: 0 0 10px;
          color: #FF9A78;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 2.2px;
          text-transform: uppercase;
        }
        .brand-title {
          z-index: 1;
          margin: 0;
          font-size: clamp(22px, 3vw, 30px);
          font-weight: 800;
          letter-spacing: -.5px;
        }
        .brand-caption {
          z-index: 1;
          max-width: 290px;
          margin: 12px 0 0;
          color: #DDE6F0;
          font-size: 14px;
          line-height: 1.7;
        }
        .login-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 58px clamp(28px, 6vw, 64px);
        }
        .login-eyebrow {
          margin: 0 0 10px;
          color: #C9432B;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 1.6px;
          text-transform: uppercase;
        }
        .login-title {
          margin: 0;
          color: #0B1F3A;
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          letter-spacing: -1px;
        }
        .login-subtitle {
          margin: 10px 0 30px;
          color: #64748B;
          font-size: 14px;
          line-height: 1.6;
        }
        .login-form { display: flex; flex-direction: column; gap: 18px; }
        .login-field { display: flex; flex-direction: column; gap: 8px; }
        .login-field label {
          color: #26364A;
          font-size: 13px;
          font-weight: 700;
        }
        .login-field input {
          width: 100%;
          min-height: 50px;
          padding: 0 15px;
          border: 1px solid #D8E0EA;
          border-radius: 10px;
          outline: none;
          background: #F8FAFC;
          color: #0B1F3A;
          font: inherit;
          font-size: 14px;
          transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
        }
        .login-field input::placeholder { color: #94A3B8; }
        .login-field input:focus {
          border-color: #173D68;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(23, 61, 104, .12);
        }
        .login-error {
          margin: 0;
          padding: 11px 13px;
          border: 1px solid #FECACA;
          border-radius: 9px;
          background: #FEF2F2;
          color: #B91C1C;
          font-size: 13px;
        }
        .login-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-height: 52px;
          margin-top: 4px;
          border: 0;
          border-radius: 10px;
          background: linear-gradient(100deg, #0B1F3A, #173D68);
          box-shadow: 0 10px 20px rgba(11, 31, 58, .18);
          color: #fff;
          cursor: pointer;
          font: inherit;
          font-size: 14px;
          font-weight: 800;
          transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
        }
        .login-button:hover {
          transform: translateY(-1px);
          background: linear-gradient(100deg, #061426, #0B1F3A);
          box-shadow: 0 13px 24px rgba(11, 31, 58, .24);
        }
        .login-button:focus-visible { outline: 3px solid #FF9A78; outline-offset: 3px; }
        .login-button span { color: #FF9A78; font-size: 18px; line-height: 1; }
        .login-footer {
          margin: 28px 0 0;
          color: #94A3B8;
          font-size: 11px;
          letter-spacing: .35px;
          text-align: center;
        }
        @media (max-width: 680px) {
          .login-page { padding: 18px 14px; }
          .login-shell { grid-template-columns: 1fr; max-width: 460px; min-height: 0; }
          .login-brand { min-height: 245px; padding: 24px; }
          .login-logo { width: 170px; max-height: 125px; margin-bottom: 12px; padding: 7px; border-radius: 12px; }
          .brand-kicker { margin-bottom: 5px; font-size: 9px; }
          .brand-title { font-size: 22px; }
          .brand-caption { margin-top: 6px; font-size: 12px; }
          .login-content { padding: 34px 26px 30px; }
          .login-subtitle { margin-bottom: 23px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .login-field input, .login-button { transition: none; }
        }
      `}</style>

      <section className="login-shell" aria-label="LAR Contracting Company sign in">
        <div className="login-brand">
          <img className="login-logo" src={logo} alt="LAR Contracting Company logo" />
          <p className="brand-kicker">Leadership · Accountability · Reliability</p>
          <h1 className="brand-title">LAR Contracting</h1>
          <p className="brand-caption">Commercial document management for your business.</p>
        </div>

        <div className="login-content">
          <p className="login-eyebrow">Welcome back</p>
          <h2 className="login-title">Sign in</h2>
          <p className="login-subtitle">Enter your account details to continue to the document workspace.</p>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="login-username">Username</label>
              <input
                id="login-username"
                type="text"
                name="username"
                autoComplete="username"
                placeholder="Enter your username"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                  setError('');
                }}
                required
              />
            </div>
            <div className="login-field">
              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="Enter your password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setError('');
                }}
                required
              />
            </div>
            {error && <p className="login-error" role="alert">{error}</p>}
            <button className="login-button" type="submit">
              Sign in <span aria-hidden="true">→</span>
            </button>
          </form>
          <p className="login-footer">LAR CONTRACTING COMPANY · SECURE ADMIN ACCESS</p>
        </div>
      </section>
    </main>
  );
}
